export const LANGUAGE_VERSIONS = {
  python: "3.10.0",
  java: "15.0.2",
  c: "10.2",
  go: "1.21.0"
};

export const CODE_SNIPPETS = {
  c: `// Online C compiler to run C program online
    #include <stdio.h>
    
    int main() {
        // Write C code here
        printf("Try writing your C code here!");
    
        return 0;
    }
    `,
  python: `# Online Python compiler to run Python program online
# Write Python code here
print("Hello, World!")
`,
  java: `// Online Java compiler to run Java program online
    public class Main {
        public static void main(String[] args) {
            // Write Java code here
            System.out.println("Hello, World!");
        }
    }
    `,
  go: `// Online Go compiler to run Go program online
package main

import "fmt"

func main() {
    // Write Go code here
    fmt.Println("Hello, World!")
}
`,
};
